import React from 'react';
import PropTypes from 'prop-types';

import {
  TextInput,
} from '../../../fragments/forms';

export default class TitleInput extends React.Component {

  static propTypes = {
    reference: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
    showError: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  handleUpdate(title) {
    const {reference} = this.props;
    reference.title = title;
    const {onUpdate} = this.props;
    onUpdate(reference);
  }

  get helpMessage() {
    return {
      level: 'info',
      text: <div>
        The title without capitalizing every word and end with a period.
        <br/>
        <em>(for example: "Predominance of a rare type of HIV-1 in Estonia.")</em>
      </div>
    };
  }

  get allMessage() {
    const {helpMessage} = this;
    const {reference, showError} = this.props;

    return [helpMessage].concat(
      reference.messages('title', showError)
    );
  }

  render() {
    const {reference, readOnly} = this.props;
    const {allMessage} = this;

    return (
      <TextInput
       name="title"
       readOnly={readOnly}
       value={reference.title}
       onChange={this.handleUpdate.bind(this)}
       messages={allMessage}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/reference-edit/title-input.js